import { CartThreeDigitBoldIcon, CartTwoDigitBoldIcon, CartOneDigitBoldIcon, CartEmptyBoldIcon, CartThreeDigitIcon, CartTwoDigitIcon, CartOneDigitIcon, CartEmptyIcon } from '@kohler-dsm-library/kohler-icons';

const iconMap = {
  default: {
    0: CartEmptyIcon,
    1: CartOneDigitIcon,
    2: CartTwoDigitIcon,
    3: CartThreeDigitIcon
  },
  bold: {
    0: CartEmptyBoldIcon,
    1: CartOneDigitBoldIcon,
    2: CartTwoDigitBoldIcon,
    3: CartThreeDigitBoldIcon
  }
};

export { iconMap };
